<template>
 <div id="master">
  <dd-header></dd-header>
  <!-- 上部タブ -->
  <nav id="main_nav">
   <ul class="container">
    <li class=" choosing_tab main_tab">
      <h2>マスター登録</h2>
    </li>
   </ul>
  </nav>
  <div class="container_main">
    <!-- 左部サイドバー -->
    <nav class="sidebar_left">
      <div class="side_menu">
        <section>
          <ul>
            <dt>
              <h3>マスター一覧</h3>
            </dt>
            <dd v-for="(table,index) in tableList" :key="index">
              <a @click="getTableInfoAndAllData(table, pageNo, dataCount); selectedMenu(index)" class="menu-table" v-bind:class="{select_menu: selectMenuNo==index}">・{{ table }}</a>
            </dd>
          </ul>
        </section>
      </div>
    </nav>
    <!--  メインコンテンツ  -->
    <main v-if="tableModel && tableModel.tableName">
      <dd-table
        :tableModel="tableModel"
        :totalCount="totalCount"
        :pageNo="pageNo"
        :dataCount="dataCount"
        @getTableInfoAndAllData="getTableInfoAndAllData"
      />
    </main>
    <main v-else>
      <span id="not_select_table">テーブルが選択されていません。</span>
    </main>
  </div>
  <dd-footer />
 </div>
</template>
<script>
// Libraries
import axios from 'axios'
// Module
import {API_URL} from '../constants/App'
import * as Api from '../utils/Api'
import Header from '../components/common/Header'
import Footer from '../components/common/Footer'
import Table from '../components/master/Table'

export default {
  name: 'Master',
  components: {
    'dd-header': Header,
    'dd-footer': Footer,
    'dd-table': Table
  },
  data () {
    return {
      /** テーブルデータ */
      tableModel: {},
      /** テーブルリスト */
      tableList: [],
      /** ページ番号 */
      pageNo: 1,
      /** 1ページごとの表示件数 */
      dataCount: 10,
      /** 対象のテーブルレコード数 */
      totalCount: 0,
      /** 選択メニュー */
      selectMenuNo: -1
    }
  },
  methods: {
    /** ページング処理 */
    getTableInfoAndAllData: function (param1, param2, param3) {
      if (param1 !== this.tableModel.tableName) {
        this.pageNo = 1
      } else {
        this.pageNo = param2
      }
      axios.get(API_URL.MASTER + '/' + param1 + '/' + param2 + '/' + param3)
        .then(response => {
          this.tableModel = response.data.data
          this.getTableRows(this.tableModel.tableName)
        }).catch(error => {
          Api.handleError(error)
        })
    },
    /** 全テーブル取得 */
    getTableList: function () {
      axios.get(API_URL.MASTER + '/list')
        .then(response => {
          this.tableList = response.data.data
        }).catch(error => {
          Api.handleError(error)
        })
    },
    /** 各テーブルのレコード数取得 */
    getTableRows: function (param) {
      axios.get(API_URL.MASTER + '/rows/' + param
      ).then(response => {
        this.totalCount = response.data.data
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
      })
    },
    selectedMenu: function (selectNo) {
      this.selectMenuNo = selectNo
    }
  },
  created: function () {
    this.getTableList()
  }
}
</script>
<style src="../css/master/master.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/pages/Master.vue